<template>
  <div>
    <dialog-ticket-filter ref="DialogTicketFilter" />
    <dialog-add-ticket ref="DialogAddTicket" />
    <dialog-edit-ticket ref="DialogEditTicket" />

  <v-tabs-items v-model="getCurrentTicketTab">
    <v-tab-item>
      <v-data-table
          :headers="ticketsHeaders"
          :items="receiveTicketsData"
          sort-by="calories"
          class="elevation-1"
      >
        <template v-slot:top>
          <v-toolbar flat>
            <v-toolbar-title>{{getTitleTickets}}</v-toolbar-title>
            <v-divider
                class="mx-4"
                inset
                vertical
            ></v-divider>
            <v-spacer></v-spacer>

<!--            Кнопка настройка фильтар-->
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn small class="mt-2" outlined fab color="primary" @click="clickTicketsFilter" v-bind="attrs" v-on="on">
                  <v-icon>mdi-cog-outline</v-icon>
                </v-btn>
              </template>
              <span>Настройка фильтра</span>
            </v-tooltip>


          </v-toolbar>
        </template>
        <template v-slot:[`item.files`]="{ item }">
          <v-icon small class="mr-2" v-if="item.files.length>0">
            mdi-paperclip
          </v-icon>
        </template>

        <template v-slot:[`item.actions`]="{ item }">
          <v-icon small class="mr-2" @click="editItem(item)">
            mdi-pencil
          </v-icon>
          <v-icon small @click="deleteItem(item)">
            mdi-delete
          </v-icon>
        </template>

        <template v-slot:no-data>
          <div v-html="$t('TicketsPage.plugs.receiveTickets')"
               style="border: 2px dashed orange; border-radius: 10px"
               class="ma-2 pa-3 mt-5"
          ></div>

        </template>
      </v-data-table>
    </v-tab-item>

    <v-tab-item>
      <v-data-table
          :headers="ticketsHeaders"
          :items="shipmentTicketsData"
          sort-by="calories"
          class="elevation-1"
      >
        <template v-slot:top>
          <v-toolbar flat>
            <v-toolbar-title>{{getTitleTickets}}</v-toolbar-title>
            <v-divider
                class="mx-4"
                inset
                vertical
            ></v-divider>
            <v-spacer></v-spacer>

            <!--            Кнопка настройка фильтар-->
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn small class="mt-2" outlined fab color="primary" @click="clickTicketsFilter" v-bind="attrs" v-on="on">
                  <v-icon>mdi-cog-outline</v-icon>
                </v-btn>
              </template>
              <span>Настройка фильтра</span>
            </v-tooltip>

          </v-toolbar>
        </template>

        <template v-slot:[`item.files`]="{ item }">
          <v-icon small class="mr-2" v-if="item.files.length>0">
            mdi-paperclip
          </v-icon>
        </template>

        <template v-slot:[`item.actions`]="{ item }">
          <v-icon small class="mr-2" @click="editItem(item)">
            mdi-pencil
          </v-icon>
          <v-icon small @click="deleteItem(item)">
            mdi-delete
          </v-icon>
        </template>

        <template v-slot:no-data>
          <div v-html="$t('TicketsPage.plugs.shipmentTickets')"
               style="border: 2px dashed orange; border-radius: 10px"
               class="ma-2 pa-3 mt-5"
          ></div>

        </template>
      </v-data-table>
    </v-tab-item>

    <v-tab-item>
      <v-data-table
          :headers="ticketsHeaders"
          :items="nomenclatureTicketsData"
          sort-by="calories"
          class="elevation-1"
      >
        <template v-slot:top>
          <v-toolbar flat>
            <v-toolbar-title>{{getTitleTickets}}</v-toolbar-title>
            <v-divider
                class="mx-4"
                inset
                vertical
            ></v-divider>
            <v-spacer></v-spacer>

            <!--            Кнопка настройка фильтар-->
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn small class="mt-2" outlined fab color="primary" @click="clickTicketsFilter" v-bind="attrs" v-on="on">
                  <v-icon>mdi-cog-outline</v-icon>
                </v-btn>
              </template>
              <span>Настройка фильтра</span>
            </v-tooltip>

          </v-toolbar>
        </template>

        <template v-slot:[`item.files`]="{ item }">
          <v-icon small class="mr-2" v-if="item.files.length>0">
            mdi-paperclip
          </v-icon>
        </template>

        <template v-slot:[`item.actions`]="{ item }">
          <v-icon small class="mr-2" @click="editItem(item)">
            mdi-pencil
          </v-icon>
          <v-icon small @click="deleteItem(item)">
            mdi-delete
          </v-icon>
        </template>

        <template v-slot:no-data>
          <div v-html="$t('TicketsPage.plugs.loadDirectory')"
               style="border: 2px dashed orange; border-radius: 10px"
               class="ma-2 pa-3 mt-5"
          ></div>

        </template>
      </v-data-table>
    </v-tab-item>

    <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <v-btn color="pink" dark bottom right fab fixed @click="fabClick" v-bind="attrs" v-on="on">
          <v-icon>mdi-plus</v-icon>
        </v-btn>

      </template>
      <span>Добавить заявку</span>
    </v-tooltip>


  </v-tabs-items>


  </div>
</template>

<script>

import { mapGetters, mapActions, mapMutations } from "vuex"
import DialogTicketFilter from "@/components/dialogs/DialogTicketFilter.vue"
import DialogAddTicket from "@/components/dialogs/DialogAddTicket.vue"
import DialogEditTicket from "@/components/dialogs/DialogEditTicket.vue"
import {fileToBase64} from "@/domain/utils";
export default {
  name: "TicketsPage",
  components: {DialogTicketFilter, DialogAddTicket, DialogEditTicket},

  data() {
    return {
      ticketsHeaders: [
        { text: '№ заявки', align: 'start', sortable: true, value: 'ticketNumber',},
        { text: 'Дата заявки', value: 'ticketDate' },
        { text: 'Локация', value: 'ticketLocation' },
        { text: 'Статус', value: 'ticketStatus' },
        { text: 'Вложения', value: 'files' },
        { text: 'Действия', value: 'actions', sortable: false },
      ],

    }
  },
  methods: {

    ...mapActions("app", ["apiNewTicket", "apiDeleteTicket", "apiGetTickets"]),
    ...mapMutations("app", ["setTicketsFilter"]),

    async editItem(item){
      //switch (item.)
      const result = await this.$refs.DialogEditTicket.show({...item})
      console.log(result)
    },

    async editItemByGuid(guid){
      let items = [];
      items = this.receiveTicketsData.filter(item=>item.GUID === guid);
      if (items.length === 1) {
        await this.editItem(items[0]);
        this.$router.push({ name: "MyTicketsPage" })
        return;
      }

      items = this.shipmentTicketsData.filter(item=>item.GUID === guid);
      if (items.length === 1) {
        await this.editItem(items[0]);
        this.$router.push({ name: "MyTicketsPage" })
        return;
      }

      items = this.nomenclatureTicketsData.filter(item=>item.GUID === guid);
      if (items.length === 1) {
        await this.editItem(items[0]);
        this.$router.push({ name: "MyTicketsPage" })
        return;
      }

    },

    async deleteItem(item){

      if (item.ticketStatus!=="Новый"){
        await this.appRefs.DialogInfo.show({
          title: this.$t("dialogs.DialogNoDeleteTicket.title"),
          message: this.$t("dialogs.DialogNoDeleteTicket.message"),
          positive: this.$t("common.button_ok"),
        })
      }else {
        const result = await this.appRefs.DialogYesNo.show({
          title: this.$t("dialogs.DialogDeleteTicket.title"),
          message: this.$t("dialogs.DialogDeleteTicket.message"),
          negative: this.$t("common.button_cancel"),
          positive: this.$t("common.button_yes"),
        })
        if (result.answer==="positive"){
          await this.apiDeleteTicket({
            GUID: item.GUID
          })
        }
      }
    },

    async clickTicketsFilter(){

      const result = await this.$refs.DialogTicketFilter.show({...this.getTicketsFilter})


      if (result.answer === "positive"){
        console.log(result)
        this.setTicketsFilter({
              date1: result.form.date1,
              date2: result.form.date2,
              locationsId: result.form.locations,
              statuses:  result.form.statuses
        }
        )
        await this.apiGetTickets(this.getTicketsFilter)
      }

    },

    async fabClick(){
      let ticketTitle = "Заявка"
      let ticketType = "other"
      let description = "Описание..."
      switch (this.getCurrentTicketTab){
        case 0: //Заявки на приемку
          ticketTitle = "Заявка на приемку"
          ticketType  = "ЗаявкаНаПриемку "

          description =
            'Для отправки заявки на приёмку груза, пожалуйста, выполните следующие шаги:<br/>' +
            '<ol>'+
            '<li>Выберите локацию – склад, на который будет осуществляться приёмка груза</li>' +
            '<li>Скачайте <a href="/static/Образец%20заявки%20на%20приёмку%20на%20хранение.xlsx">шаблон</a> файла заявки на приёмку и заполните его данными предстоящего прихода</li>' +
            '<li>Вложите заполненный файл в поле «файл для отправки»</li>' +
            '<li>Если необходимо - укажите комментарии к заявке в соответствующем поле</li>' +
            '<li>Нажмите кнопу «отправить»</li>' +
            '</ol>'+
            '<br/>'+
            'Если это ваша первая заявка на приёмку, и ранее вы не отправляли нам справочник товаров, ' +
            'пожалуйста загрузите справочник в соответствующем разделе заявок.'
          // description = 'Описание со ссылкой <a href="/static/Образец%20заявки%20на%20приёмку%20на%20хранение.xlsx">Скачать</a>'
          //console.log(`Заявки на приемку`)
          break
        case 1: //Заявки на отгрузку
          ticketTitle = "Заявка на отгрузку"
          ticketType  = "ЗаявкаНаОтгрузку"
          //description = 'Описание со ссылкой <a href="/static/Образец%20заявки%20на%20выдачу%20с%20хранения.xlsx">Скачать</a>'
          description =
            'Для отправки заявки на отгрузку (выдачу) товара, пожалуйста, выполните следующие шаги:<br/>' +
            '<ol>'+
            '<li>Выберите локацию – склад, с которого будет осуществляться отгрузка</li>' +
            '<li>Скачайте <a href="/static/Образец%20заявки%20на%20выдачу%20с%20хранения.xlsx">шаблон</a> файла заявки на отгрузку и заполните его данными</li>' +
            '<li>Вложите заполненный файл в поле «файл для отправки»</li>' +
            '<li>Если необходимо - укажите комментарии к заявке в соответствующем поле</li>' +
            '<li>Нажмите кнопу «отправить»</li>'+
          '</ol>'
          //console.log(`Заявки на отгрузку`)
          break
        case 2: //Справочники
          ticketTitle = "Заявка загрузку справочника"
          ticketType  = "ЗагрузкаСправочников"
          // description = 'Описание со ссылкой <a href="/static/Образец%20электронного%20справочника%20товаров.xlsx">Скачать</a>'
          description =
            'Загрузка справочников товара выполняется однократно перед началом складских операций ' +
            'и повторно – в случае каких-либо изменений в товарной номенклатуре.<br/>' +
            'Для отправки справочника товаров, пожалуйста, выполните следующие шаги:<br/>' +
            '<ol>'+
            '<li>Выберите локацию – склад, на котором будет храниться и обрабатываться товар</li>' +
            '<li>Скачайте <a href="/static/Образец%20электронного%20справочника%20товаров.xlsx">шаблон</a> справочника и заполните его данными</li>' +
            '<li>Вложите заполненный файл в поле «файл для отправки»</li>' +
            '<li>Если необходимо  - укажите комментарии к справочнику в соответствующем поле</li>' +
            '<li>Нажмите кнопу «отправить»</li>'+
            '</ol>'
          //console.log(`Справочники`)
          break
        case 3: //Произвольный запрос
          ticketTitle = "Произвольный запрос"
          ticketType  = "ПрочийЗапрос"
          //console.log(`Произвольный запрос`)
          break
      }

      const result = await this.$refs.DialogAddTicket.show({title: ticketTitle, description: description})
      console.log(result)
      if (result.answer === "positive"){
        console.log(result)
        const fileBase64 = await fileToBase64(result.form.file)
        let additional_files = []
        if (result.form.additional_files!==undefined && result.form.additional_files.length!==0){
          for (const file of result.form.additional_files){
            console.log(file)
            additional_files.push({type:'', fileName: file.name, base64: await fileToBase64(file)})
          }
        }

        await this.apiNewTicket({
          ticketType: ticketType,
          locationId: result.form.location,
          comment: result.form.comment,
          files:[
            {
              type: result.form.file.name,
              fileName: result.form.file.name,
              base64: fileBase64
            },
            ...additional_files
          ]
        });
      }

    },
  },
  watch: {

  },
  computed: {
    ...mapGetters('app',["getCurrentTicketTab", "getTickets", "getTicketsFilter"]),

    receiveTicketsData(){
      let arr=[]
      this.getTickets.filter(element=>element.ticketType==="ЗаявкаНаПриемку").forEach(element=>{
        console.log(element)
        arr.push({
          ticketNumber: element.number,
          ticketDate: element.date,
          ticketLocation: element.location,
          ticketStatus: element.status,
          comment: element.comment,
          files: element.files,
          ticketType: element.ticketType,
          GUID: element.GUID
        })
      })
      return arr
    },

    shipmentTicketsData(){
      let arr=[]
      this.getTickets.filter(element=>element.ticketType==="ЗаявкаНаОтгрузку").forEach(element=>{
        console.log(element)
        arr.push({
          ticketNumber: element.number,
          ticketDate: element.date,
          ticketLocation: element.location,
          ticketStatus: element.status,
          comment: element.comment,
          files: element.files,
          ticketType: element.ticketType,
          GUID: element.GUID
        })
      })
      return arr
    },

    nomenclatureTicketsData(){
      let arr=[]
      this.getTickets.filter(element=>element.ticketType==="ЗагрузкаСправочников").forEach(element=>{
        console.log(element)
        arr.push({
          ticketNumber: element.number,
          ticketDate: element.date,
          ticketLocation: element.location,
          files: element.files,
          ticketStatus: element.status,
          comment: element.comment,
          ticketType: element.ticketType,
          GUID: element.GUID
        })
      })
      return arr
    },

    getTitleTickets(){
      if (!this.getTicketsFilter.date1 && !this.getTicketsFilter.date2 && (this.getTicketsFilter.locations && this.getTicketsFilter.locations.length===0) && (this.getTicketsFilter.statuses && this.getTicketsFilter.statuses.length===0)){
        return "Без фильтров"
      }
      let period = ((this.getTicketsFilter.date1 && this.getTicketsFilter.date1!=='') && (this.getTicketsFilter.date2 && this.getTicketsFilter.date2!=='')) ? `${this.getTicketsFilter.date1} - ${this.getTicketsFilter.date2}` : "Не выбран"
      let locations = (this.getTicketsFilter.locations && this.getTicketsFilter.locations.length > 0) ? this.getTicketsFilter.locations.join(', '): "Не выбраны"
      let statuses = (this.getTicketsFilter.statuses && this.getTicketsFilter.statuses.length > 0) ? this.getTicketsFilter.statuses.join(', '): "Не выбраны"
      return `Период: ${period}, Локации: ${locations}, Статусы: ${statuses}`
    }

  },
  created() {},
  mounted() {
    const url = new URL(window.location.href);
    const guid = url.searchParams.get('guid');
    if (guid!==null){
      this.editItemByGuid(guid);
    }

  },
  inject:['appRefs']
}
</script>
